<article
  class="registration-card"
  [class.registration-card--linked]="hasCardRouterLink">
  @if (hasCardRouterLink) {
    <a
      class="registration-card__overlay-link"
      [routerLink]="cardRouterLink"
      [queryParams]="cardRouterQueryParams"
      [attr.aria-label]="cardLinkLabel">
    </a>
  }

  <div
    class="registration-card__hero"
    [class.registration-card__hero--empty]="!backgroundImgUrl"
    [class.registration-card__hero--with-logo]="orgLogoUrl"
    [style.background-image]="backgroundImage">
    @if (orgLogoUrl) {
      <span
        class="registration-card__avatar-badge registration-card__avatar-badge--org"
        aria-hidden="true">
        <img
          class="registration-card__logo"
          [src]="orgLogoUrl"
          [alt]="orgName + ' logo'">
      </span>
    }

    <div class="registration-card__hero-content">
      <p class="registration-card__org-name">{{ orgName }}</p>
      <h3 class="registration-card__hero-title">{{ registrationName }}</h3>
      @if (sport || type) {
        <p class="registration-card__hero-meta">
          @if (sport) {
            <span>{{ sport }}</span>
          }
          @if (sport && type) {
            <span aria-hidden="true">&bull;</span>
          }
          @if (type) {
            <span>{{ type }}</span>
          }
        </p>
      }
    </div>

    @if (buttonLinkUrl && showShareAction) {
      <se-fe-icon-button
        class="registration-card__share-action"
        seFeDataType="button"
        [seFeDataSmall]="true"
        [seFeDataButtonAttrs]="{ 'aria-label': shareLabel }"
        (click)="handleShareActionClick()">
        <se-fe-icon seFeDataName="share_android_fill" [seFeDataMargin]="false"></se-fe-icon>
      </se-fe-icon-button>
    }
  </div>

  <div
    class="registration-card__body"
    [class.registration-card__body--with-avatar]="avatarUrl">
    @if (avatarUrl) {
      <div
        class="registration-card__profile-avatar"
        aria-hidden="true">
        <span
          class="registration-card__avatar-badge registration-card__avatar-badge--person">
          <img
            class="registration-card__avatar-image"
            [src]="avatarUrl"
            [alt]="registrationName + ' avatar'">
        </span>
      </div>
    }

    @if (infoHeaderText || infoText) {
      <section class="registration-card__status">
        @if (infoHeaderText) {
          <h4 class="registration-card__status-title">{{ infoHeaderText }}</h4>
        }
        @if (infoText) {
          <p class="registration-card__status-text">{{ infoText }}</p>
        }
      </section>
    }

    @if (hasOrderRouterLink) {
      @if (absoluteOrderHref) {
        <a
          class="registration-card__order-link"
          [href]="absoluteOrderHref">
          {{ orderLinkText }}
        </a>
      } @else {
        <a
          class="registration-card__order-link"
          [routerLink]="orderRouterLink"
          [queryParams]="orderRouterQueryParams">
          {{ orderLinkText }}
        </a>
      }
    }

    @if (buttonLinkUrl && buttonText && !avatarUrl) {
      <se-fe-button
        class="registration-card__button-action"
        seFeDataEmphasis="high"
        seFeDataType="button"
        [seFeDataFullWidth]="true"
        (click)="handlePrimaryActionClick()">
        {{ buttonText }}
      </se-fe-button>
    }
  </div>
</article>
